import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import {
  REORDER_LESSON_PLANS,
  REORDER_LESSON_PLANS_FAIL,
  REORDER_LESSON_PLANS_SUCCESS,
  ReorderLessonPlansAction
} from '../redux/lessonPlansReducer'
import { LessonPlan } from '../types'

function* ReorderLessonFlow(action: ReorderLessonPlansAction): Generator<any, void, any> {
  try {
    const response: LessonPlan[] = yield call(apiCall, {
      endpoint: `/tutors/units/${action.payload.unitId}/lesson_plans/reorder`,
      method: 'POST',
      params: { reorder_params: action.payload.ids }
    })
    yield put(REORDER_LESSON_PLANS_SUCCESS({ unitId: action.payload.unitId, lessonPlans: response }))
  } catch (error) {
    yield put(REORDER_LESSON_PLANS_FAIL())
    console.log(error)
  }
}

export default function* ReorderLessonPlan(): Generator<any, void, any> {
  yield takeLatest([REORDER_LESSON_PLANS], ReorderLessonFlow)
}
